import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateFormatEnum } from '@enums/date-format.enum';
import { format } from 'date-fns';
import { FormatTimePipe } from '@shared/pipes/format-time/format-time.pipe';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private datePipe: DatePipe, private formatTimePipe: FormatTimePipe) {}

  public dateComparator(a: Date, b: Date): -1 | 0 | 1 {
    const aDate = new Date(a).valueOf();
    const bDate = new Date(b).valueOf();

    if (aDate < bDate) {
      return -1;
    }
    if (aDate > bDate) {
      return 1;
    }
    return 0;
  }

  public getDateRangeIndicator(departure: string, arrival: string): string {
    const result = this.dateComparator(new Date(arrival), new Date(departure));
    return result > 0 ? `+${result}` : '';
  }

  public formatDate(unformattedDate: string | Date, endFormat: DateFormatEnum): string {
    return format(new Date(unformattedDate), endFormat);
  }

  public formatTime(time): string {
    return this.formatTimePipe.transform(time);
  }

  public formatDateTime(date: string, format: string): string {
    return this.datePipe.transform(date, format);
  }
}
